import { Component, inject, OnInit } from '@angular/core';
import { FormBuilder, ReactiveFormsModule, Validators } from '@angular/forms';

import { TranslateModule } from '@ngx-translate/core';

import { ButtonComponent } from '@atoms/button/button.component';
import { ColorTextComponent } from '@atoms/color-text/color-text.component';
import { FormComponent } from '@atoms/form/form.component';
import { FormInputsComponent } from '@atoms/form/form-inputs/form-inputs.component';
import { InputComponent } from '@atoms/input/input.component';
import { ParagraphComponent } from '@atoms/paragraph/paragraph.component';
import { ModalMainContentComponent } from '@molecules/modal/modal-main-content/modal-main-content.component';
import { ModalHeaderComponent } from '@molecules/modal/modal-header/modal-header.component';
import { ModalMainComponent } from '@molecules/modal/modal-main/modal-main.component';
import { ModalTitleComponent } from '@molecules/modal/modal-title/modal-title.component';
import { ThousandsPipe } from '@pipes/thousands.pipe';
import { ModalService } from '@services/modal.service';
import { OnlineFormService } from '@services/online-form.service';
import { SaveFormService } from '@services/save-form.service';

@Component({
  selector: 'app-online-form-address-modal',
  imports: [ReactiveFormsModule, TranslateModule, ButtonComponent, ColorTextComponent, FormComponent, FormInputsComponent, InputComponent, ParagraphComponent, ModalMainContentComponent, ModalHeaderComponent, ModalMainComponent, ModalTitleComponent, ThousandsPipe],
  templateUrl: './online-form-address-modal.component.html',
  styleUrl: './online-form-address-modal.component.scss',
})
export class OnlineFormAddressModalComponent implements OnInit {
  private fb = inject(FormBuilder);
  private modalService = inject(ModalService);
  private onlineFormService = inject(OnlineFormService);
  private saveFormService = inject(SaveFormService);
  public form = this.fb.nonNullable.group({
    street: ['', { nonNullable: true, validators: [Validators.required] }],
    zip: ['', { nonNullable: true, validators: [Validators.required] }],
    city: ['', { nonNullable: true, validators: [Validators.required] }],
  });

  send(): void {
    if (this.form.invalid) return;
    this.onlineFormService.formData.update((formData) => {
      formData.deliveryType = 'address';
      formData.deliveryAddress = {
        street: this.form.value.street || '',
        zip: this.form.value.zip || '',
        city: this.form.value.city || '',
      };
      return formData;
    });
    this.saveData();
    this.modalService.close();
  }

  saveData(): void {
    this.saveFormService.editForm(this.onlineFormService.formId());
  }

  ngOnInit(): void {
    this.form.patchValue({
      street: this.onlineFormService.formData().deliveryAddress?.street || '',
      zip: this.onlineFormService.formData().deliveryAddress?.zip || '',
      city: this.onlineFormService.formData().deliveryAddress?.city || '',
    });
  }
}
